var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-wait',{attrs:{"for":_vm.loaderName},scopedSlots:_vm._u([{key:"waiting",fn:function(){return [_vm._t("loader",function(){return [_c('eqify-loader')]})]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }